<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'ONT Mac Address Table'"
          style="height: 100%"
          :closeButton="false"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadOntMacTable()"
                  class="btn"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
            <span style="margin-left: 25px; font-weight: bold"
              >Total entries: {{ total }}</span
            >
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in ontMacTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 100%">
              <tr v-for="row in ontMacTable.data" :key="row.mac">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontMacTable",
  data() {
    return {
      ontMacTable: "",
      total: 0,
    }
  },
  props: ["ontIndex"],
  components: {
    BlockCntr,
  },
  created() {
    this.loadOntMacTable()
  },
  methods: {
    loadOntMacTable() {
      get("ontMacTable?ontIndex=" + this.ontIndex)
        .then((res) => {
          this.ontMacTable = res.data
          this.total = this.ontMacTable.data.length
        })
        .catch((err) => {
          this.ontMacTable = en.ontMacTable
          this.total = this.ontMacTable.data.length
        })
    },
  },
}
</script>